"use client";

import { createAuthClient } from "better-auth/react";
import { organizationClient, usernameClient } from "better-auth/client/plugins";

/**
 * Better-Auth Client Configuration
 * baseURL = current origin (or NEXT_PUBLIC_APP_URL) so auth works behind proxy (nginx, etc.)
 */
const baseURL =
  typeof window !== "undefined"
    ? window.location.origin
    : process.env.NEXT_PUBLIC_APP_URL || "http://localhost:3000";

export const authClient = createAuthClient({
  baseURL,
  plugins: [organizationClient(), usernameClient()],
});

export const {
  signIn,
  signUp,
  signOut,
  useSession,
  organization,
  useActiveOrganization,
  useListOrganizations,
} = authClient;

/**
 * Déconnexion + redirection garantie vers /login (à utiliser dans les boutons Déconnexion).
 * Gère toutes les erreurs/rejets pour éviter des Runtime Error "undefined" (unhandled rejection).
 */
export function logoutAndRedirect(): void {
  const loginUrl = typeof window !== "undefined" ? `${window.location.origin}/login` : "/login";

  const doRedirect = () => {
    if (typeof window !== "undefined") {
      window.location.href = loginUrl;
    }
  };

  Promise.resolve()
    .then(() => signOut())
    .catch(() => {}) // ignorer toute erreur ou rejet (y compris undefined)
    .finally(doRedirect);
}
